import {
  Cars64,
  HouseDIY64,
  Animals64,
  SportsHobbies64,
  Electronics64,
  ClothesLifestyle64,
  CarsMotors64,
  Farming64,
  BabyKids64,
  Business64,
  HolidaysTickets64,
  LostFound64,
  MusicEducation64,
  Property64,
  ServicesForHire64,
  AllCarsMotors64,
} from '../../../components/Toolkit/Base64/Sections';

export interface Map {
  [name: string]: JSX.Element;
}

const MarketplaceIcons: Map = {
  cars: <Cars64 alt="" />,
  household: <HouseDIY64 alt="" />,
  animals: <Animals64 alt="" />,
  sport: <SportsHobbies64 alt="" />,
  homeelectronics: <Electronics64 alt="" />,
  fashion: <ClothesLifestyle64 alt="" />,
  motor: <CarsMotors64 alt="" />,
  farming: <Farming64 alt="" />,
  babyandkids: <BabyKids64 alt="" />,
  business: <Business64 alt="" />,
  tickets: <HolidaysTickets64 alt="" />,
  lostfound: <LostFound64 alt="" />,
  music: <MusicEducation64 alt="" />,
  property: <Property64 alt="" />,
  'services-for-hire': <ServicesForHire64 alt="" />,
  all: <AllCarsMotors64 alt="" />,
};

export default MarketplaceIcons;
